const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then((webVitals) => {
      if (!webVitals) {
        console.warn('web-vitals module is empty');
        return;
      }

      // Safely call each metric function with individual try-catch
      const callMetric = (metricFn, name) => {
        try {
          if (metricFn && typeof metricFn === 'function') {
            metricFn(onPerfEntry);
          }
        } catch (error) {
          console.warn(`Failed to report ${name}:`, error);
        }
      };

      // Safely destructure named exports (web-vitals v5)
      try {
        const { onCLS, onINP, onFCP, onLCP, onTTFB } = webVitals;
        
        callMetric(onCLS, 'CLS');
        callMetric(onINP, 'INP');
        callMetric(onFCP, 'FCP');
        callMetric(onLCP, 'LCP');
        callMetric(onTTFB, 'TTFB');
      } catch (error) {
        console.warn('Failed to destructure web-vitals exports:', error);
      }
    }).catch((error) => {
      // Silently fail if web-vitals can't be loaded
      console.warn('Failed to load web-vitals:', error);
    });
  }
};

export default reportWebVitals;
